import { ReactNode } from 'react';

import { Callable, Optional } from '@vimeo/core/types/generic';

export enum EConfirmationType {
  SCREEN_SHARE_OVERTAKE = 1,
  GRAPHICS_REPLACEMENT,
  GUEST_REMOVAL,
  AGORA_CONNECTION_FAILED,
  UNMUTE_REQUEST,
  SLIDES_CONVERTATION,
  MEDIA_PERMISSIONS_DENIED,
  ADMIN_CONNECTION_DETECTED,
  MEDIA_DEVICE_OCCUPIED_BY_ANOTHER_APPLICATION,
  REMOVE_ALL_SCENES,
}

export enum EConfirmationVariant {
  GLOBAL = 1,
}

export interface IConfirmationNotification {
  type?: EConfirmationType;
  variant?: EConfirmationVariant;
  header?: ReactNode;
  body?: ReactNode;
  confirmMessage?: string;
  declineMessage?: Optional<string>;
  onConfirm?: Callable;
  onDecline?: Callable;
  modalWidth?: number;
  showDismissButton?: boolean;
}

export enum ESimpleNotificationStatus {
  INFO = 'info',
  ERROR = 'error',
}

export interface ISimpleNotification {
  status?: ESimpleNotificationStatus;
  message: string;
  onComplete?: Callable;
}
